<div class="container ">
    <div class="col-md-10 col-sm-12 pl-0">
        <div class="rating-heading">
            <h5 class="rps-heading-five">Ratings</h5>
        </div>
        <div class="row">
            <div class="col-md-6 rating-container">
                <p class="risk-reward rps-paragraph-two">Risk / reward scale</p>
                <risk-scale *ngIf="overviewModel?.riskCode; else mdash" [data]="overviewModel"></risk-scale>
                <ng-template #mdash>
                    <p data-rpa-tag-id="risk">&mdash;</p>
                </ng-template>
            </div>
        </div>
        <div>
            <a class="link dialog-button" role="button" href="javascript:void(0)" (click)="ratingsDialog.openModalDialog()" tabindex="0">
                Why should I care about risk?</a>
        </div>
    </div>
</div>

<c11n-modal-dialog modalId="ratingsDialog" headingText="Why should I care about risk?" #ratingsDialog>
    <div c11n-modal-dialog-body>
        <p [innerHTML]="riskScale?.contentValue" class="copy rps-paragraph-one"></p>
        <br>
        <h2 class="dialog-subheader">Conservative funds</h2>
        <p class="copy-copy-10 rps-paragraph-one">Risk level 1</p><br>
        <risk-scale [data]="riskCodeCollection[0].index"></risk-scale>
        <br>
        <p [innerHTML]="riskScaleOne?.contentValue" class="copy rps-paragraph-one"></p>
        <br><br>
        <h2 class="dialog-subheader">Conservative to moderate funds</h2>
        <p class="copy-copy-10 rps-paragraph-one">Risk level 2</p><br>
        <risk-scale [data]="riskCodeCollection[1].index"></risk-scale>
        <br>
        <p [innerHTML]="riskScaleTwo?.contentValue" class="copy rps-paragraph-one"></p>
        <br><br>
        <h2 class="dialog-subheader">Moderate funds</h2>
        <p class="copy-copy-10 rps-paragraph-one">Risk level 3</p><br>
        <risk-scale [data]="riskCodeCollection[2].index"></risk-scale>
        <br>
        <p [innerHTML]="riskScaleThree?.contentValue" class="copy rps-paragraph-one"></p>
        <br><br>
        <h2 class="dialog-subheader">Moderate to aggressive funds</h2>
        <p class="copy-copy-10 rps-paragraph-one">Risk level 4</p><br>
        <risk-scale [data]="riskCodeCollection[3].index"></risk-scale>
        <br>
        <p [innerHTML]="riskScaleFour?.contentValue" class="copy rps-paragraph-one"></p>
        <br><br>
        <h2 class="dialog-subheader">Aggressive funds</h2>
        <p class="copy-copy-10 rps-paragraph-one">Risk level 5</p><br>
        <risk-scale [data]="riskCodeCollection[4].index"></risk-scale>
        <br>
        <p [innerHTML]="riskScaleFive?.contentValue" class="copy rps-paragraph-one"></p>
        <br>
    </div>
</c11n-modal-dialog>